import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { Payer } from '../../models/payer';

const getOtherPayerIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Payer>) => memoize((
        ids: Undefinable<number>[]
    ) => ids.filter(x => x && !byId[x]) as number[])
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getOtherPayerIds: (
        state: State,
        ids: Undefinable<number>[]
    ): number[] => getOtherPayerIdsSelector(state)(ids),
    getPayer: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<Payer> => state.byId[id || ''],
    getPayerHash: (
        state: State
    ): Dictionary<Payer> => state.byId,
    getPayerIds: (
        state: State
    ): number[] => state.allIds
};
